import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-update-is-valid-dialog',
  templateUrl: './update-validation-dialog.component.html',
  styleUrls: ['./update-validation-dialog.component.scss'],
  standalone: false,
})
export class UpdateValidationDialogComponent {
  maxCharacterLength = 4000;

  constructor(
    public dialogRef: MatDialogRef<UpdateValidationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  onNoClick(): void {
    this.data.reason = '';
    this.dialogRef.close();
  }
}

export interface DialogData {
  reason: string;
}
